import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Form, InputGroup, Card } from "react-bootstrap";

import { UpdateJobLevelName, UpdateJobLevelDescription, UpdateJobLevelState, ClearJobLevelState } from "../../Store";
import { getAllJobLevels, createJobLevel, updateJobLevel, deleteJobLevel } from "../../Store/Thunk";

export default function JobLevel() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const jobLevelList = useSelector((state) => state.organization.jobLevelList);
  const jobLevelName = useSelector((state) => state.organization.jobLevelName);
  const jobLevelDescription = useSelector((state) => state.organization.jobLevelDescription);
  const jobLevelId = useSelector((state) => state.organization.jobLevelId);
  const isUpdateOperation = useSelector((state) => state.organization.isJobLevelUpdateOperation);

  useEffect(() => {
    dispatch(getAllJobLevels());
  }, [dispatch]);

  const submitForm = (event) => {
    event.preventDefault();

    if (isUpdateOperation) {
      dispatch(
        updateJobLevel({
          id: jobLevelId,
          name: jobLevelName,
          description: jobLevelDescription,
        })
      );
    } else {
      dispatch(
        createJobLevel({
          name: jobLevelName,
          description: jobLevelDescription,
        })
      );
    }

    dispatch(ClearJobLevelState());
  };

  const handleUpdateButton = (item) => {
    dispatch(
      UpdateJobLevelState({
        id: item.id,
        name: item.name,
        description: item.description || "",
        isUpdateOperation: true,
      })
    );
  };

  const handleDeleteButton = (id) => {
    dispatch(deleteJobLevel(id));
  };

  return (
    <div>
      <Card body className="mb-3 default-card admin-form">
        <Form onSubmit={submitForm}>
          <Row>
            <Col xs={12} md={5}>
              <h6>{isUpdateOperation ? `${t("update")}: ${jobLevelId}` : t("jobLevelName")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  required
                  name="name"
                  placeholder={t("enterJobLevelName")}
                  value={jobLevelName}
                  onChange={(e) => dispatch(UpdateJobLevelName(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={5}>
              <h6>{t("description")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  name="description"
                  placeholder={t("enterDescription")}
                  value={jobLevelDescription}
                  onChange={(e) => dispatch(UpdateJobLevelDescription(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={2}>
              <Row style={{ height: !isUpdateOperation && "100%", margin: 0 }}>
                <Button
                  className="mb-1"
                  type="submit"
                  style={{ width: "100%", height: "100%" }}
                  variant="primary"
                  disabled={!jobLevelName}
                >
                  {isUpdateOperation ? t("update") : t("create")}
                </Button>
              </Row>
              {isUpdateOperation && (
                <Row style={{ margin: 0 }}>
                  <Button
                    style={{ width: "100%", height: "100%" }}
                    variant="secondary"
                    onClick={() => dispatch(ClearJobLevelState())}
                  >
                    {t("decline")}
                  </Button>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Card>

      <h5>{t("jobLevelList")}</h5>
      {jobLevelList &&
        jobLevelList.map((item, i) => (
          <Card className="mb-2" key={"jobLevel" + i}>
            <Card.Body>
              <Row className="align-items-center">
                <Col xs={1}>{item.id}</Col>
                <Col xs={3}>{item.name}</Col>
                <Col xs={5}>{item.description}</Col>
                <Col xs={3}>
                  <Row xs="auto" className="justify-content-end">
                    <Col>
                      <Button size="sm" variant="success" onClick={() => handleUpdateButton(item)}>
                        {t("updateButtonLabel")}
                      </Button>
                    </Col>
                    <Col>
                      <Button size="sm" variant="danger" onClick={() => handleDeleteButton(item.id)}>
                        {t("deleteButtonLabel")}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
    </div>
  );
}
